import { render } from "./SetTeamPassword.vue?vue&type=template&id=581dfdd5&scoped=true"
import script from "./SetTeamPassword.vue?vue&type=script&lang=js"
export * from "./SetTeamPassword.vue?vue&type=script&lang=js"

import "./SetTeamPassword.vue?vue&type=style&index=0&id=581dfdd5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581dfdd5"]])

export default __exports__